/* eslint-disable */
import styled, { css } from 'styled-components';

export const LinkContainer = styled.a`
    width: 100%;
    padding: ${(props) => props.theme.spacers.L};
    display: flex;
    align-items: center;
    ${({ theme }) => css(theme.typography.SmallHeadline)};
    color: #000;
    text-decoration: none;

    ${props => props.disabled && `
        color: ${props.theme.colors['Level 4']};
        pointer-events: none;
    `}

    &:active,
    &:focus,
     &:hover {
      color: #000
    }

    & svg {
      margin-right: 8px;
      width: 24px;
      height: 24px;
    }
`;
